// extracted by mini-css-extract-plugin
module.exports = {"content_type_pic":"content_type_pic___1DyQX"};